module.exports = __webpack_public_path__ + "static/img/nia-logo-white.6bf86897.svg";